import { HouseholdMember } from "./HouseholdInfo";
import * as React from "react";
import { useState } from "react";
import SelectInput from "../commons/components/form/input/SelectInput";
import TextInput from "../commons/components/form/input/TextInput";
import { required } from "../commons/model/form/Validators";
import DateInput from "../commons/components/form/input/DateInput";
import { getI18NKey, patientRelationshipOrdered } from "../commons/model/patient/PatientRelationship";
import moment from "moment";
import Option from "../commons/model/Option";
import TextAction from "../commons/components/action/TextAction";

const patientRelationshipOptions = patientRelationshipOrdered.map(
  (patientRelationship) => new Option(patientRelationship, i18n[getI18NKey(patientRelationship)])
);

export default function HouseholdMemberEditablePanel({
  id,
  initialValue,
  onChange,
  onRemove,
}: {
  id: string;
  initialValue: HouseholdMember;
  onChange: (member: HouseholdMember) => void;
  onRemove: () => void;
}) {
  const [member, setMember] = useState(initialValue);
  function toDate(datetime: string): string {
    return datetime == "" ? "" : moment(datetime).format("YYYY-MM-DD");
  }

  function toDateTime(date: string): string {
    return date == "" ? "" : moment(date, "YYYY-MM-DD").toString();
  }

  return (
    <div className={"household-member-panel"}>
      <div className={"h-flex"}>
        <SelectInput
          options={patientRelationshipOptions}
          initialValue={member.relationship}
          name={`relationship-${id}`}
          label={i18n["Form.Household.Field.Title.RelationshipToPatient"]}
          placeholder={"Select an item"}
          validators={[required()]}
          onChange={(inputState) => {
            const newValue = {
              ...initialValue,
              relationship: inputState.value,
            } as HouseholdMember;
            setMember(newValue);
            onChange(newValue);
          }}
        />

        <TextAction
          icon="ic_trash"
          label={i18n["Global.Remove"]}
          additionalClass={"input-group danger remove-action x2"}
          onClick={onRemove}
        />
      </div>
      <div className={"h-flex"}>
        <TextInput
          name={`firstname-${id}`}
          label={i18n["Form.Household.Field.Title.FirstName"]}
          placeholder={i18n["Form.Field.Placeholder.FirstName"]}
          initialValue={member.firstName}
          validators={[required()]}
          onChange={(inputState) => {
            const newValue = {
              ...initialValue,
              firstName: inputState.value,
            } as HouseholdMember;
            setMember(newValue);
            onChange(newValue);
          }}
        />
        <TextInput
          name={`lastname-${id}`}
          label={i18n["Form.Household.Field.Title.LastName"]}
          placeholder={i18n["Form.Field.Placeholder.LastName"]}
          initialValue={member.lastName}
          validators={[required()]}
          onChange={(inputState) => {
            const newValue = {
              ...initialValue,
              lastName: inputState.value,
            } as HouseholdMember;
            setMember(newValue);
            onChange(newValue);
          }}
        />
        <DateInput
          name={`birthdate-${id}`}
          label={i18n["Form.Household.Field.Title.Birthdate"]}
          placeholder={i18n["Form.Field.Placeholder.Birthdate"]}
          initialValue={toDateTime(member.birthdate)}
          validators={[required()]}
          onChange={(inputState) => {
            const newValue = {
              ...initialValue,
              birthdate: toDate(inputState.value),
            } as HouseholdMember;
            setMember(newValue);
            onChange(newValue);
          }}
        />
      </div>
    </div>
  );
}
